import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import SeguradoraProvider from "./SeguradoraContext";
import PesquisarSeguradora from "./Events/PesquisarSeguradora";
import FormularioSeguradora from "./Events/FormularioSeguradora";

const Index = () => {
  let match = useRouteMatch();
  return (
    <SeguradoraProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarSeguradora}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioSeguradora}
          />
        </Switch>
      </div>
    </SeguradoraProvider>
  );
};

export default Index;
